// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-cis{
    width: 100%;
    height: 100%;
    position: relative;
    /* background-color: rgb(1, 17, 31); */
    background-color:var(--white-color) ;
    display: block;
    justify-content: center;
    align-items: center;
}
.main-cisDark{
    width: 100%;
    height: 100%;
    position: relative;
    /* background-color: rgb(1, 17, 31); */
    background-color:var(--main-color) ;
    display: block;
    justify-content: center;
    align-items: center;
}

.head-cis{
    position: relative;
    display: block;
    width: 100%;
    height: 15%;
/* background-color: rgba(195,195,195,1); */
/* border-bottom: 1px solid rgba(195,195,195,1); */
}
.head-cis-half{
    position: relative;
    display: flex;
    width: 100%;
    height: 50%;
}
.cont-head-cis-info{
    position: relative;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.title-cis{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.txt-title-cis{
    /* color: rgba(195,195,195,1); */
    color: #003757;
    font-size: xx-large;
}
.menu-cis{
    position: relative;
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    height: 50%;
}
.head-line{
width: 90%;
position: absolute;
left: 5%;
top:85%;
/* color:rgba(195,195,195,1); */
color: 003757;
}
.compact-menu-list{
    position: relative;
    display: flex;
    width: 40%;
    height: 100%;
    left: 5%;
    justify-content: center;
    align-items: center;
    justify-content: space-between; /* Distribuye el espacio entre los elementos */
  list-style-type: none; /* Elimina los estilos de viñetas de la lista */
  padding: 0; /* Elimina el relleno predeterminado de la lista */
  margin: 0; 
}
.compact-menu-list li {
    /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */
    width: 25%;
    height: 50%;
    background-color: transparent;
    border-right: 1px solid #a1a1a150;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: medium;
    cursor: pointer;
    /* color: rgba(195,195,195,1); */
    color: #003757;
  }
  .compact-menu-list li:hover{
    background-color: rgba(130, 134, 138, 0.452);
  }
.list-selected{
    /* background-color: rgba(195,195,195,1) !important; */
    background-color: #003757 !important;
    /* color: rgb(1, 17, 31) !important; */
    color:aliceblue !important;
}
.cont-cis{
    position: relative;
    display: block;
    width: 100%;
    height: 85%;
/* background-color: rgb(95, 95, 95); */
 
}

.cont-result-registers{
    position: absolute;
    width: 15%;
    height: 30px;
    bottom: 20px;
    left: 15px;
    color: var(--txt-color) ;
    font-size: var(--font-size-med);
}
.cont-result-registersDark{
    position: absolute;
    width: 15%;
    height: 30px;
    bottom: 20px;
    left: 15px;
    color: var(--white-color) ;
    font-size: var(--font-size-med);
}
.cont-buttons-panel{
    position: absolute;
    width: 10%;
    height: 30px;
    /* background-color: #003757; */
    right: 20px;
    top: 15px;
}

/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and (max-width: 900px) {
    .cont-cis{
      height: 83%;
    }
    .cont-buttons-panel{
        width: 15%;
    }
    .cont-excels-buttons-portafolio{
		width: 25% !important;
		left: 75% !important;
	}
    .cont-result-registers{
		width: 20%;
		bottom: 0px;
	}
  }
  
  /* ****************************Movil****************************** */
  @media (max-width: 500px) {
    .cont-result-registers{
        width: 20%;
		/* bottom: 0px; */
    }
    .cont-buttons-panel{
        width: 25%;
        right: 5px;
    }
    /* .cont-excels-buttons-portafolio{
        width: 45% !important;
		left: 55% !important;
    } */
    .main-cis{
        overflow: auto;
    }
    .main-config{
        overflow: auto;
    }
    .head-reportes{
        width: 300% !important;
    }
    .head-cis{
        width: 300%;
    }
    .cont-cis{
        width: 300%;
    }
    .movil-mini{
        width: 100% !important;
    }
    .ReactModal__Content{
        width: 80% !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/sections/styles/cis.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,oCAAoC;IACpC,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,mCAAmC;IACnC,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;AACf,2CAA2C;AAC3C,kDAAkD;AAClD;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gCAAgC;IAChC,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;AACA,UAAU;AACV,kBAAkB;AAClB,QAAQ;AACR,OAAO;AACP,+BAA+B;AAC/B,aAAa;AACb;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B,EAAE,8CAA8C;EAChF,qBAAqB,EAAE,+CAA+C;EACtE,UAAU,EAAE,kDAAkD;EAC9D,SAAS;AACX;AACA;IACI,yEAAyE;IACzE,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,4CAA4C;EAC9C;AACF;IACI,sDAAsD;IACtD,oCAAoC;IACpC,sCAAsC;IACtC,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;AACf,uCAAuC;;AAEvC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,WAAW;IACX,SAAS;AACb;;AAEA,gFAAgF;AAChF;IACI;MACE,WAAW;IACb;IACA;QACI,UAAU;IACd;IACA;EACF,qBAAqB;EACrB,oBAAoB;CACrB;IACG;EACF,UAAU;EACV,WAAW;CACZ;EACC;;EAEA,oEAAoE;EACpE;IACE;QACI,UAAU;EAChB,iBAAiB;IACf;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;;;OAGG;IACH;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,qBAAqB;IACzB;EACF","sourcesContent":[".main-cis{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    /* background-color: rgb(1, 17, 31); */\r\n    background-color:var(--white-color) ;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.main-cisDark{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    /* background-color: rgb(1, 17, 31); */\r\n    background-color:var(--main-color) ;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.head-cis{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 15%;\r\n/* background-color: rgba(195,195,195,1); */\r\n/* border-bottom: 1px solid rgba(195,195,195,1); */\r\n}\r\n.head-cis-half{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 50%;\r\n}\r\n.cont-head-cis-info{\r\n    position: relative;\r\n    display: flex;\r\n    width: 50%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.title-cis{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.txt-title-cis{\r\n    /* color: rgba(195,195,195,1); */\r\n    color: #003757;\r\n    font-size: xx-large;\r\n}\r\n.menu-cis{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: left;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 50%;\r\n}\r\n.head-line{\r\nwidth: 90%;\r\nposition: absolute;\r\nleft: 5%;\r\ntop:85%;\r\n/* color:rgba(195,195,195,1); */\r\ncolor: 003757;\r\n}\r\n.compact-menu-list{\r\n    position: relative;\r\n    display: flex;\r\n    width: 40%;\r\n    height: 100%;\r\n    left: 5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    justify-content: space-between; /* Distribuye el espacio entre los elementos */\r\n  list-style-type: none; /* Elimina los estilos de viñetas de la lista */\r\n  padding: 0; /* Elimina el relleno predeterminado de la lista */\r\n  margin: 0; \r\n}\r\n.compact-menu-list li {\r\n    /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */\r\n    width: 25%;\r\n    height: 50%;\r\n    background-color: transparent;\r\n    border-right: 1px solid #a1a1a150;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    /* color: rgba(195,195,195,1); */\r\n    color: #003757;\r\n  }\r\n  .compact-menu-list li:hover{\r\n    background-color: rgba(130, 134, 138, 0.452);\r\n  }\r\n.list-selected{\r\n    /* background-color: rgba(195,195,195,1) !important; */\r\n    background-color: #003757 !important;\r\n    /* color: rgb(1, 17, 31) !important; */\r\n    color:aliceblue !important;\r\n}\r\n.cont-cis{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 85%;\r\n/* background-color: rgb(95, 95, 95); */\r\n \r\n}\r\n\r\n.cont-result-registers{\r\n    position: absolute;\r\n    width: 15%;\r\n    height: 30px;\r\n    bottom: 20px;\r\n    left: 15px;\r\n    color: var(--txt-color) ;\r\n    font-size: var(--font-size-med);\r\n}\r\n.cont-result-registersDark{\r\n    position: absolute;\r\n    width: 15%;\r\n    height: 30px;\r\n    bottom: 20px;\r\n    left: 15px;\r\n    color: var(--white-color) ;\r\n    font-size: var(--font-size-med);\r\n}\r\n.cont-buttons-panel{\r\n    position: absolute;\r\n    width: 10%;\r\n    height: 30px;\r\n    /* background-color: #003757; */\r\n    right: 20px;\r\n    top: 15px;\r\n}\r\n\r\n/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n    .cont-cis{\r\n      height: 83%;\r\n    }\r\n    .cont-buttons-panel{\r\n        width: 15%;\r\n    }\r\n    .cont-excels-buttons-portafolio{\r\n\t\twidth: 25% !important;\r\n\t\tleft: 75% !important;\r\n\t}\r\n    .cont-result-registers{\r\n\t\twidth: 20%;\r\n\t\tbottom: 0px;\r\n\t}\r\n  }\r\n  \r\n  /* ****************************Movil****************************** */\r\n  @media (max-width: 500px) {\r\n    .cont-result-registers{\r\n        width: 20%;\r\n\t\t/* bottom: 0px; */\r\n    }\r\n    .cont-buttons-panel{\r\n        width: 25%;\r\n        right: 5px;\r\n    }\r\n    /* .cont-excels-buttons-portafolio{\r\n        width: 45% !important;\r\n\t\tleft: 55% !important;\r\n    } */\r\n    .main-cis{\r\n        overflow: auto;\r\n    }\r\n    .main-config{\r\n        overflow: auto;\r\n    }\r\n    .head-reportes{\r\n        width: 300% !important;\r\n    }\r\n    .head-cis{\r\n        width: 300%;\r\n    }\r\n    .cont-cis{\r\n        width: 300%;\r\n    }\r\n    .movil-mini{\r\n        width: 100% !important;\r\n    }\r\n    .ReactModal__Content{\r\n        width: 80% !important;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
